/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 1 hook(s) need dependency review; fix each and remove this directive */
import { useEffect, useRef, useState } from "react";

const useLoadExternalScripts = ({ customScripts, customStyles }: any = {}) => {
  const scripts = customScripts || ["/js/pdf.min.js"];
  const styles = customStyles || ["/css/Common.css", "/css/NoteText.css"];

  const [scriptsLoaded, setScriptsLoaded] = useState(false);
  const totalLoadedScript = useRef(0);

  const scriptLoaded = () => {
    totalLoadedScript.current += 1;
    if (totalLoadedScript.current == scripts.length) {
      setScriptsLoaded(true);
    }
  };

  useEffect(() => {
    scripts.map((url: any) => {
      const script = document.createElement("script");
      script.src = url;
      script.async = false;
      script.onload = () => scriptLoaded();
      document.body.appendChild(script);
    });

    styles.map((url: any) => {
      const head = document.getElementsByTagName("head")[0];
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.type = "text/css";
      link.href = url;
      head?.appendChild(link);
    });
  }, []);

  return [scriptsLoaded];
};

export default useLoadExternalScripts;
